<template lang="pug" src='./taskGadgetTabContent.pug'></template>

<script>
import IdSituacaoTarefaEnum from '../../../enum/idSituacaoTarefa'
import FiltroSituacaoTarefaEnum from '../../../enum/tipoFiltroSituacaoTarefas'
import PATHS from '../../../router/routesMap.js'

export default {
  name: 'TaskGadgetTabContent',

  props: {
    data: {
      type: Object
    },
    quantidadeMovFin: {
      type: Number,
      required: true
    },
    quantidadeMovBan: {
      type: Number,
      required: true
    },
    totalQuantidade: {
      type: Number,
      required: true
    },
    isPendentTab: {
      type: Boolean
    }
  },

  data () {
    return {
      naoConcluido: [IdSituacaoTarefaEnum.PENDENTE, IdSituacaoTarefaEnum.EM_ANDAMENTO, IdSituacaoTarefaEnum.AGUARDANDO],
      concluido: [IdSituacaoTarefaEnum.CONCLUIDO],
      tipoNaoConcluido: FiltroSituacaoTarefaEnum.NC,
      tipoConcluido: FiltroSituacaoTarefaEnum.C
    }
  },

  methods: {
    getTextNextExpiration () {
      if (!this.data || !this.data.dataProximoVencimento) {
        return this.$t('estatistica.tarefa.labels.semDataProximoVencimento')
      }

      return `${this.$t('estatistica.tarefa.labels.dataProximoVencimento')} <b>${this.data.dataProximoVencimento}</b>.`
    },

    redirectToTasks (situations, type) {
      let arraySituations = situations.split(',').map(function (situation) {
        return Number(situation)
      })
      let typeFilter = {
        arraySituations: arraySituations,
        type: type,
        dateFirstDue: this.data && this.data.dataPrimeiroVencimento ? this.data.dataPrimeiroVencimento : null,
        fromDashboard: true
      }
      if (arraySituations && arraySituations.length > 0) {
        this.$store.dispatch('setFilterTasksList', typeFilter)
          .then(() => {
            this.$router.push(PATHS.LIST_ASSIGNMENT)
          })
      } else {
        self.$root.$refs.notification.error('GENERAL')
      }
    }
  }
}
</script>

<style lang="scss">
.boxBorderRight {
  border-right: 2px solid #d9d9d9;
}

.boxQtde {
  padding-top: 15px;
  height: 125px;
  margin: 0px 0px 20px 0px;
}

span.valorQtde {
  font-size: 40px;
  color: #4a4a4a;
  font-family: 'Inter', sans-serif;
font-weight: 400;
}

label.valorQtdeTxt {
  font-family: 'Inter', sans-serif;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #b0b0b0;
  margin-top: 8px;
}

.boxTarefas {
  padding-top: 45px;
}

.alerta {
  margin-top: 10px;
  margin-bottom: 30px;

  > div div {
    display: inline-block;
    max-width: 90%;

    &.alerta-text {
      margin-left: 10px;
    }
  }

  span {
    font-family: 'Inter', sans-serif;
    font-size: 15px;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #4a4a4a;
    margin-bottom: 15px;

    &.link {
      font-family: 'Inter', sans-serif;
font-weight: 700;
      color: #00ABEA;
      font-size: 15px;
      cursor: pointer;
    }
  }
}

.badge-custom-tasks {
  padding: 5px 2px;
  background-color: #f55753 !important;
  border-radius: 50%;
  min-width: 30px;
  right: 5px;
  font-family: 'Inter', sans-serif;
font-weight: 700;
  font-size: 18px;
  color: #ffffff;
  vertical-align: top !important;
}
</style>



// WEBPACK FOOTER //
// TaskGadgetTabContent.vue?602b9e0d